module.exports = __webpack_public_path__ + "img/add-circle-outline-dark.6a80ef4c.svg";